import { Clock, Download } from "lucide-react";
import { Button } from "../ui/button";
import React, { useEffect } from "react";
import { Card } from "../ui/card";
import TimelineEvent from "./timeLine";
import { Input } from "../ui/input";
import { useSelector } from "react-redux";
import { getHistoryData } from "../../api/historyService";
import { useState } from "react";

const data = [
  { label: "Total APIs", value: 18 },
  { label: "Total Events", value: 10 },
  { label: "High Impact", value: 3, color: "text-red-500" },
  { label: "Email Events", value: 2, color: "text-blue-500" },
  { label: "Decisions", value: 1, color: "text-green-500" }
];

const SummaryStats = ({ stats }) => {
  return (
    <div className="flex items-center justify-center bg-gray-50 rounded-lg px-6 py-4 shadow-sm text-sm mb-6">
      {stats.map((item, index) => (
        <React.Fragment key={item.label}>
          <div className="flex flex-col items-center justify-center flex-1 min-w-0">
            <div
              className={`text-lg font-semibold ${
                item.color ?? "text-gray-900"
              }`}
            >
              {item.value}
            </div>
            <div className="text-gray-500 whitespace-nowrap">{item.label}</div>
          </div>

          {/* Slash separator */}
          {index === 0 && <div className="w-[1.5px] h-12 bg-gray-200" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export function HistoryTab ({ timelineData }) {
  if (!timelineData || timelineData.length === 0) {
    return null;
  }

  return (
    <Card className="p-5 bg-white shadow-md h-full overflow-auto">
      {/* Header */}
      <div className="flex justify-between items-start">
        <h3 className="text-base font-semibold flex items-center">
          <Clock className="h-4 w-4 mr-2 text-[#FF5533]" />
          Application Timeline
        </h3>
        <Button variant="outline" size="sm">
          <Download className="h-4 w-4 mr-1" />
          Export History
        </Button>
      </div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm text-gray-500">
          Complete history of application lifecycle with all interactions and
          updates
        </h2>
      </div>
      {/* Filters */}
      {/* <div className="flex flex-wrap items-center gap-4 mb-4">
        <Input
          type="text"
          placeholder="Search events, descriptions, or content..."
          className="flex-1 border px-3 py-2 rounded text-sm"
        />
        <select className="text-sm border pl-2 pr-4 py-2.5 rounded">
          <option>Newest First</option>
          <option>Oldest First</option>
        </select>
        <select className="text-sm border pl-2 pr-4 py-2.5 rounded">
          <option>All Events</option>
        </select>
        <select className="text-sm border pl-2 pr-4 py-2.5 rounded">
          <option>All Time</option>
        </select>
      </div> */}

      {/* Summary */}
      {/* <SummaryStats stats={data} /> */}

      {/* Vertical Line */}
      <div className="relative pl-6">
        <div className="absolute left-4 top-0 bottom-0 w-px bg-gray-300" />
        <div className="space-y-4">
          {timelineData.map((event, index) => (
            <TimelineEvent
              key={index}
              mailDetails={event.mail_details}
              fileDetails={event.file_details}
            />
          ))}
        </div>
      </div>
    </Card>
  );
}
